var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-google-autocomplete", {
    ref: "vueAutocompleteRef",
    attrs: {
      id: _vm.id,
      classname: "form material-input form-control " + _vm.className,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      tabindex: _vm.tabindex,
      types: _vm.addressResultTypes,
      fields: _vm.autocompleteFields,
      country: "ca",
    },
    on: {
      placechanged: _vm.handleChange,
      blur: function ($event) {
        return _vm.$emit("focusout", $event)
      },
      focus: function ($event) {
        return _vm.$emit("focus", $event)
      },
      change: _vm.handleValueChange,
      inputChange: _vm.handleInputChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }